"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.themes = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const colors = {
    white: "#FFFFFF",
    orange: {
        50: "#FFE1B8",
        100: "#FFD8A3",
        200: "#FFC77A",
        300: "#FFB652",
        400: "#FFA429",
        500: "#FF9300",
        600: "#C77300",
        700: "#8F5200",
        800: "#573200",
        900: "#1F1200"
    },
    green: {
        50: "#3AFFA0",
        100: "#25FF96",
        200: "#00FB83",
        300: "#00D36D",
        400: "#00AA58",
        500: "#008143",
        600: "#004926",
        700: "#001109",
        800: "#000000",
        900: "#000000"
    },
    yellow: {
        50: "#FFF2B8",
        100: "#FFEFA3",
        200: "#FFE87A",
        300: "#FFE052",
        400: "#FFD929",
        500: "#FFD200",
        600: "#C7A400",
        700: "#8F7600",
        800: "#574700",
        900: "#1F1900"
    },
    red: {
        50: "#F5BCB3",
        100: "#F3ACA1",
        200: "#EE8C7D",
        300: "#E96C59",
        400: "#E44C35",
        500: "#D4351C",
        600: "#A22915",
        700: "#711C0F",
        800: "#3F1008",
        900: "#0E0302"
    },
    grey: {
        50: "#F8F8F8",
        100: "#EDEDED",
        200: "#D9D9D9",
        300: "#BDBDBD",
        400: "#A1A1A1",
        500: "#858585",
        600: "#696969",
        700: "#4D4D4D",
        800: "#313131",
        900: "#151515"
    },
    blueGrey: {
        50: "#F3F5F9",
        100: "#E5E9F2",
        200: "#C0C9DF",
        300: "#9AAACD",
        400: "#758ABA",
        500: "#526BA4",
        600: "#40537F",
        700: "#2D3B5A",
        800: "#1A2234",
        900: "#070A0F"
    }
};
const lightTheme = {
    white: colors.white,
    background: {
        primary: colors.blueGrey[100],
        secondary: colors.grey[800]
    },
    primary: {
        dark: colors.orange[600],
        main: colors.orange[500],
        light: colors.orange[400],
        lighter: colors.orange[100]
    },
    success: {
        dark: colors.green[600],
        main: colors.green[500],
        light: colors.green[400],
        lighter: colors.green[200]
    },
    warning: {
        dark: colors.yellow[600],
        main: colors.yellow[500],
        light: colors.yellow[400],
        lighter: colors.yellow[200]
    },
    error: {
        dark: colors.red[600],
        main: colors.red[500],
        light: colors.red[400],
        lighter: colors.red[200]
    },
    neutral: {
        dark: colors.grey[700],
        main: colors.grey[400],
        light: colors.grey[200],
        lighter: colors.grey[50]
    },
    text: {
        primary: colors.grey[900],
        secondary: colors.grey[400]
    }
};
const darkTheme = {
    white: colors.white,
    background: {
        primary: colors.grey[800],
        secondary: colors.grey[700]
    },
    primary: {
        dark: colors.orange[600],
        main: colors.orange[500],
        light: colors.orange[400],
        lighter: colors.orange[100]
    },
    success: {
        dark: colors.green[600],
        main: colors.green[500],
        light: colors.green[400],
        lighter: colors.green[200]
    },
    warning: {
        dark: colors.yellow[600],
        main: colors.yellow[500],
        light: colors.yellow[400],
        lighter: colors.yellow[200]
    },
    error: {
        dark: colors.red[600],
        main: colors.red[500],
        light: colors.red[400],
        lighter: colors.red[200]
    },
    neutral: {
        dark: colors.grey[700],
        main: colors.grey[400],
        light: colors.grey[200],
        lighter: colors.grey[50]
    },
    text: {
        primary: colors.white,
        secondary: colors.grey[400]
    }
};
exports.themes = {
    light: lightTheme,
    dark: darkTheme
};
const ThemeProvider = ({ children, theme = exports.themes.light }) => {
    return react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme }, children);
};
exports.ThemeProvider = ThemeProvider;
